(() => {
  const init = () => {
    const product = document.querySelector('product-info.canalla-pdp');
    if (!product) return;
    product.dataset.pdpReady = 'true';
    if (window.variantStrings) window.variantStrings.soldOut = product.dataset.soldOut;
    product.querySelectorAll('[data-canalla-review-close]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const review = button.closest('.canalla-pdp__featured-review');
      const reopen = review?.querySelector('[data-canalla-review-reopen]');
      if (!review || !reopen) return;
      button.addEventListener('click', () => {
        review.classList.add('is-minimized');
        reopen.hidden = false;
        reopen.setAttribute('aria-expanded', 'false');
        reopen.focus({ preventScroll: true });
      });
      reopen.addEventListener('click', () => {
        review.classList.remove('is-minimized');
        reopen.setAttribute('aria-expanded', 'true');
        reopen.hidden = true;
        button.focus({ preventScroll: true });
      });
    });
    document.querySelectorAll('[data-canalla-media]').forEach((group) => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[data-canalla-tab]')];
      const activate = (selected) => {
        tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !active;
          if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(tabs[next]);
        });
      });
    });
    document.querySelectorAll('a[href="#canalla-gift-conditions"]').forEach((link) => {
      link.addEventListener('click', () => {
        const details = document.getElementById('canalla-gift-conditions');
        if (details) details.open = true;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
